<template>
  <section class="evento-lux">

    <div class="linea-divisora"></div>

    <article ref="card2" class="card" aria-label="Celebración">
      

      <img class="icono" src="@/assets/10.avif" alt="" />

      <h3 class="titulo-script">Celebración</h3>

      <p class="hora">5:30 PM</p>

      <p class="lugar">
        Fortune Ballroom 
      </p>

      <p class="direccion">
      1661 N Fortune 500 Ave<br> Odessa, Texas.
      </p>

      <a
        ref="btn2"
        class="btn-rosa"
        href="https://maps.app.goo.gl/c2QaDPbyP1TShsXC9"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>

      <img class="flor-inferior-derecha" src="@/assets/fn.png" alt="" />

    </article>

  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',

  setup() {
    const card1 = ref(null)
    const card2 = ref(null)

    const btn1 = ref(null)
    const btn2 = ref(null)

    const animCard = (cardEl, btnEl) => {
      if (!cardEl) return

      const $ = gsap.utils.selector(cardEl)

      const brillos = $('.brillos-bg')
      const icono  = $('.icono')
      const titulo = $('.titulo-script')
      const hora   = $('.hora')
      const lugar  = $('.lugar')
      const dir    = $('.direccion')
      const nota   = $('.ceremonia-nota')
      const florEsquina = $('.flor-inferior-derecha')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 85%',
          toggleActions: 'play none none none'
        },
        defaults: {
          ease: 'power2.out'
        }
      })

      tl.from(cardEl, {
        opacity: 0,
        y: 60,
        scale: 0.95,
        duration: 0.8
      })

      // Animación consecutiva para los brillos decorativos de fondo
      .from(brillos, {
        opacity: 0,
        scale: 0.8,
        duration: 1.2,
        ease: 'power1.out'
      }, '-=0.6')

      .from(icono, {
        opacity: 0,
        y: 25,
        scale: 0.6,
        rotation: -15,
        duration: 0.7,
        ease: 'back.out(1.7)'
      }, '-=0.8')

      .from(titulo, {
        opacity: 0,
        y: 25,
        duration: 0.5
      }, '-=0.4')

      .from(hora, {
        opacity: 0,
        x: -30,
        duration: 0.4
      }, '-=0.3')

      .from(lugar, {
        opacity: 0,
        x: 30,
        duration: 0.4
      }, '-=0.4')

      .from(dir, {
        opacity: 0,
        y: 20,
        duration: 0.5
      }, '-=0.3')

      .from(nota, {
        opacity: 0,
        y: 25,
        scale: 0.9,
        duration: 0.7,
        ease: 'back.out(1.7)'
      }, '-=0.2')

      .from(btnEl, {
        opacity: 0,
        scale: 0.85,
        duration: 0.5,
        ease: 'back.out(1.7)'
      }, '-=0.3')

      // Entrada suave con rotación para la flor en la esquina inferior derecha
      .from(florEsquina, {
        opacity: 0,
        scale: 0.7,
        rotation: 15,
        duration: 0.9
      }, '-=0.4')

      // ✨ brillo botón
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const shine = btnEl?.querySelector('.sheen')
          if (!shine) return

          gsap.fromTo(
            shine,
            {
              xPercent: -120,
              opacity: 0
            },
            {
              xPercent: 140,
              opacity: 1,
              duration: 1,
              ease: 'power2.out'
            }
          )

          if (nota.length) {
            // ✨ latido suave si existiera la nota
            gsap.to(nota, {
              scale: 1.03,
              duration: 2,
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut'
            })
          }
        }
      })
    }

    onMounted(() => {
      animCard(card1.value, btn1.value)
      animCard(card2.value, btn2.value)
    })

    return {
      card1,
      card2,
      btn1,
      btn2
    }
  }
}
</script>

<style scoped>

/* ==================== BASE ELEGANTE ==================== */
.evento-lux{
  min-height: 100%;
  padding: 28px 18px 4px;
  display: grid;
  gap: 22px;
  place-items: center;
}

/* ==================== TARJETA ==================== */
.card{
  position: relative; /* Contexto de posicionamiento para brillos y flor */
  width: min(440px, 92vw);
  background-color: transparent;
  border: none !important; /* Forzado sin bordes */
  outline: none !important;
  box-shadow: none !important;
  padding: 24px 20px 28px;
  text-align: center;
  overflow: visible; /* Permite que las flores sobresalgan elegantemente si es necesario */
}

/* Brillos decorativos de fondo */
.brillos-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  right: 590px !important;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  z-index: -1;
  opacity: 0.85; /* Opacidad sutil configurable */
}

/* Flor inferior derecha */
.flor-inferior-derecha {
  position: absolute;
  bottom:17px !important;
  right: -75px;
  width: min(320px, 48vw);
  height: auto;
  pointer-events: none;
  z-index: 4;
  opacity: 0.75; /* Opacidad requerida */
}

/* Icono discreto */
.icono{
  width: 52px;
  height:auto;
  display:block;
  margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0,0,0,.05));
  opacity: .92;
}

/* Tipos */
.titulo-script{
  font-family: 'britishgruesa', cursive;
  font-weight: 400;
  font-size: 56px;
  color: var(--tinta);
  letter-spacing: .4px;
  margin: 4px 0 8px;
}

.hora{
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: var(--tinta);
  margin: 0 0 6px;
}

.lugar{
  font-family: 'padres', serif;
  font-size: 22px;
  color: #000;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: .14em;
}

.direccion{
  font-family: 'padres', serif;
  font-style: italic;
  color: var(--gris);
  font-size: 17px !important;
  line-height: 1.5;
  margin: 0 auto 16px;
  max-width: 90%;
}

/* 🔥 NOTA */
.ceremonia-nota{
  font-family:'padres', serif;
  font-size:17px;
  line-height:1.7;
  color:#383636;
  max-width:88%;
  margin:14px auto 18px;
  font-style:italic;
  letter-spacing:.03em;
  padding:12px 16px;
  border-radius:16px;
  background:
    linear-gradient(
      135deg,
      rgba(150, 75, 125, 0.18),
      rgba(224, 133, 183, 0.75)
    );
  border:1px solid rgba(245,201,230,.5);
  box-shadow: 0 6px 16px rgba(0,0,0,.05);
}

/* ==================== BOTÓN ROSA ==================== */
.btn-rosa{
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 20px;
  border-radius: 14px;
  background: #b9387b;
  color: #fcfcfc;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
 
  z-index: 2; /* Por encima de los brillos */
}

.btn-rosa:hover{
  transform: translateY(-1px);

  filter: brightness(1.03);
}

.btn-rosa .sheen{
  position: absolute;
  top: -30%;
  left: -30%;
  width: 60%;
  height: 160%;
  transform: rotate(20deg);
 
  pointer-events: none;
  mix-blend-mode: screen;
  opacity: 0;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px){
  .titulo-script{
    font-size: 32px;
  }
  .hora{
    font-size: 22px;
  }
  .lugar{
    font-size: 16px;
  }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce){
  *{
    transition: none !important;
    animation: none !important;
  }
}
</style>